<template>
  <div class="acquirer">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('receipt'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_MOD_RECEIPT')              
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("new_receipt") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchReceipt"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="receipt"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <!-- <template v-slot:item.acquirer="{ item }">            
              <td >
                <tr v-for="it in item.value.acquirers" :key="it.id">                  
                  <td >{{it.acquirerName}}</td>
                </tr>
              </td>
          </template>   -->

        <!-- FOR EXPANSION -->
        <template v-slot:expanded-row="{ columns, item }">
          <tr>
            <td>{{ $t("acquirer") }}</td>
            <td :colspan="columns.length" style="padding: 10px">
              <tr v-for="it in item.raw.acquirers" :key="it.id">
                <td>{{ it.acquirerName }}</td>
              </tr>
            </td>
          </tr>
        </template>

        <template v-slot:item.actions="{ item }">
          <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.value.acquirerId)" v-if="this.user_permissions.includes('Edit acquirer') || this.user_permissions.includes('All') ">mdi-pencil</v-icon>
              <v-icon color="red" small @click="compose_delete(item.value.acquirerId)" v-if="this.user_permissions.includes('Delete acquirer') || this.user_permissions.includes('All') ">mdi-delete</v-icon> -->
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="green"
                small
                class="mr-2"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_MOD_RECEIPT')                  
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_DEL_RECEIPT') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>
        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD RECEIPT DIALOG -->
    <v-dialog v-model="dialog" persistent width="1200">
      <v-card>
        <v-form ref="addDiscount" v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5"> {{ $t("new_receipt") }} </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('receipt_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="receipt_data.f_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('header1')"
                      :readonly="loading"
                      :rules="[validateLenght]"
                      clearable
                      v-model="receipt_data.f_header1"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('header2')"
                      :readonly="loading"
                      :rules="[validateLenght]"
                      clearable
                      v-model="receipt_data.f_header2"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('footer1')"
                      :readonly="loading"
                      :rules="[required, validateLenght]"
                      clearable
                      v-model="receipt_data.f_footer1"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('footer2')"
                      :readonly="loading"
                      :rules="[validateLenght]"
                      clearable
                      v-model="receipt_data.f_footer2"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_acquirers')"
                      :rules="[required]"
                      v-model="receipt_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="receipt_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addReceipt"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD RECEIPT DIALOG -->

    <!-- UPDATE RECEIPT DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="1200">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_receipt") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('receipt_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="receipt_data.f_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('header1')"
                      :readonly="loading"
                      :rules="[validateLenght]"
                      clearable
                      v-model="receipt_data.f_header1"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('header2')"
                      :readonly="loading"
                      :rules="[validateLenght]"
                      clearable
                      v-model="receipt_data.f_header2"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('footer1')"
                      :readonly="loading"
                      :rules="[required, validateLenght]"
                      clearable
                      v-model="receipt_data.f_footer1"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('footer2')"
                      :readonly="loading"
                      :rules="[validateLenght]"
                      clearable
                      v-model="receipt_data.f_footer2"
                      maxlength="60"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_acquirers')"
                      :rules="[required]"
                      v-model="receipt_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="receipt_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateReceipt"
              >
                {{ $t("Update") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE RECEIPT DIALOG -->

    <!-- DELETE RECEIPT DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">{{ $t('do you want to delete') }} ?</span></div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    {{ $t('Close') }}
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteReceipt"
                  >
                    {{ $t('Delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteReceipt">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END DELETE RECEIPT DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Receipt",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      acquirers: [],
      receipt: [],
      organization: [],
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      receipt_data: {
        f_name: "",
        f_header1: "",
        f_header2: "",
        f_footer1: "",
        f_footer2: "",
        f_acquirerList: [],
        f_orgId: "",
      },

      receiptId: "",
      receipt_response: [],
      search: "",
      headers: [
        {
          title: this.$t("receipt_name"),
          align: "start",
          sortable: false,
          key: "name",
        },
        { title: "", key: "data-table-expand" },
        { title: this.$t("header1"), key: "header1" },
        { title: this.$t("header2"), key: "header2" },
        { title: this.$t("footer1"), key: "footer1" },
        { title: this.$t("footer2"), key: "footer2" },
        // { title: this.$t("acquirer"), key: "acquirer.acquirerName", sortable: true },

        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //FOR USER DATA
      user_roles: "",
      user_org: "",
      user_permissions: [],
      //nameList:[],

      //form
      form: false,
      loading: true,
      email_exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);

      return count;
    },
    //for select all acquirers
    likesAll () {  
        //return this.selectedFruits.length === this.fruits.length
        return this.receipt_data.f_acquirerList.length === this.acquirers.length
    },
    likesSome () {
        //return this.selectedFruits.length > 0
        return this.receipt_data.f_acquirerList.length > 0
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.fetchData();
    },

     //for select all acquirers
     toggle () {
        if (this.likesAll) {
          this.receipt_data.f_acquirerList = []
        } else {
          //this.aid_data.f_acquirerList = this.acquirers.slice()
          let i = 0;
          this.receipt_data.f_acquirerList = [];
          for (i = 0; i < this.acquirers.length; i++) {
              this.receipt_data.f_acquirerList.push(
                this.acquirers[i].id
              );
          }
        }
    },

    resetInput() {
      this.receipt_data.f_name = "";
      this.receipt_data.f_header1 = "";
      this.receipt_data.f_header2 = "";
      this.receipt_data.f_footer1 = "";
      this.receipt_data.f_footer2 = "";
      this.receipt_data.f_acquirerList = [];
      this.receipt_data.f_orgId = "";
    },

    required(v) {
      return !!v || "Field is required";
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.receiptId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.receiptId = id;
      this.dialog_delete = true;
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    requests_handler() {
      //second method
      axios
        .all([
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acquirer_response) => {
            // console.log("data2", acquirer_response);

            //if response data is an array // handle it as below
            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
            //if response data is a single object // handle it as below
            /* if(second_response.status == 200){  
                  this.organization = [];  //remove all items from array
                  this.organization.push(second_response.data);                          
                  console.log("organization1", this.organization)
                  
              } */
          })
        );
    }, //end of requests_handler method

    async addReceipt() {
      //this.dialog = false
      // console.log("form data", this.receipt_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "receipts",
          {
            name: this.receipt_data.f_name,
            header1: this.receipt_data.f_header1,
            header2: this.receipt_data.f_header2,
            footer1: this.receipt_data.f_footer1,
            footer2: this.receipt_data.f_footer2,
            //orgId:this.discount_data.f_orgId,
            orgId: this.orgId,
            acquirer_id: this.receipt_data.f_acquirerList,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("log in successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("receipt_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "receipts/" + this.receiptId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((receipt_response, acquirer_response) => {
            // console.log("data1", receipt_response.data);
            // console.log("data2", acquirer_response.data);

            //get discount data for selected id and display data in for dialog
            if (receipt_response.status == 200) {
              // console.log("discount Data", this.receipt_response);
              this.receipt_data.f_name = receipt_response.data.name;
              this.receipt_data.f_header1 = receipt_response.data.header1;
              this.receipt_data.f_header2 = receipt_response.data.header2;
              this.receipt_data.f_footer1 = receipt_response.data.footer1;
              this.receipt_data.f_footer2 = receipt_response.data.footer2;
              this.receipt_data.f_acquirerList =
                receipt_response.data.acquirer.id;

              /* let i = 0;
                this.receipt_data.f_acquirerList = [];
                for(i=0; i<receipt_response.data.acquirers.length; i++){                                                 
                  
                  this.receipt_data.f_acquirerList.push(receipt_response.data.acquirers[i].acquirerId);                          
                                          
                } */
            }

            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateReceipt() {
      this.dialog_update = false;
      this.checkTokenExpiry();
      try {
        // console.log("update form receipt id", this.receiptId);
        // console.log("update form receipt", this.receipt_data);
        let result = await axios.put(
          window.baseurl + "receipts/" + this.receiptId,
          {
            name: this.receipt_data.f_name,
            header1: this.receipt_data.f_header1,
            header2: this.receipt_data.f_header2,
            footer1: this.receipt_data.f_footer1,
            footer2: this.receipt_data.f_footer2,
            orgId: this.orgId,
            acquirer_id: this.receipt_data.f_acquirerList,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form receipt result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("receipt_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteReceipt() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "receipts/" + "" + this.receiptId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("receipt_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "receipts", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("receipt_object", result);
          this.receipt = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_RECEIPT")          
        ) {
          result = await axios.get(
            window.baseurl + "receipts/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("receipt_object", result);
          this.receipt = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async searchReceipt() {
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "receipts/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_receipt_object", result);
          this.receipt = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_RECEIPT")          
        ) {
          result = await axios.get(
            window.baseurl + "receipts/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_receipt_object", result);
          this.receipt = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    validateName(value) {
      const regex = /^[A-Za-z0-9_ ]+$/;
      return regex.test(value) || "Name can only be [A-Za-z0-9_ ]";
    },
    validateDetails1(value) {
      const regex = /^[A-Za-z0-9_.@\- ]+$/;
      return (
        regex.test(value) || "Text can only be [A-Za-z0-9_. ] and 60 characters"
      );
    },
    validateDetails2(value) {
      const regex = /^[A-Za-z0-9_.@\- ]+$/;
      return (
        regex.test(value) ||
        "Text can only be [A-Za-z0-9_. ] and 60 characters."
      );
    },
    validateLenght(value) {
      if (value.length <= 60) {
        return true;
      } else {
        return "Maximum lenght should be 60 characters";
      }
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get user list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
